import {
  GET_USERS,
  GET_USERS_SUCCESS,
  GET_USERS_FAILURE,
  GET_MESSAGES,
  GET_MESSAGES_SUCCESS,
  GET_MESSAGES_FAILURE,
  GET_UNREAD_MESSAGES,
  GET_UNREAD_MESSAGES_SUCCESS,
  GET_UNREAD_MESSAGES_FAILURE,
  ADD_MESSAGE,
  ADD_MESSAGE_SUCCESS,
  ADD_MESSAGE_FAILURE,
} from "../constants";

export default class ChatbotAction {
  static getMessages(payload, cb) {
    return {
      type: GET_MESSAGES,
      payload,
      cb,
    };
  }
  static getMessagesSuccess(payload) {
    return {
      type: GET_MESSAGES_SUCCESS,
      payload,
    };
  }
  static getMessagesFailure(payload) {
    return {
      type: GET_MESSAGES_FAILURE,
      payload,
    };
  }
  static getUnreadMessages(payload, cb) {
    return {
      type: GET_UNREAD_MESSAGES,
      payload,
      cb,
    };
  }
  static getUnreadMessagesSuccess(payload) {
    return {
      type: GET_UNREAD_MESSAGES_SUCCESS,
      payload,
    };
  }
  static getUnreadMessagesFailure(payload) {
    return {
      type: GET_UNREAD_MESSAGES_FAILURE,
      payload,
    };
  }
  static getUsers(payload, cb) {
    return {
      type: GET_USERS,
      payload,
      cb,
    };
  }
  static getUsersSuccess(payload) {
    return {
      type: GET_USERS_SUCCESS,
      payload,
    };
  }
  static getUsersFailure(payload) {
    return {
      type: GET_USERS_FAILURE,
      payload,
    };
  }
  static addMessage(payload, cb) {
    return {
      type: ADD_MESSAGE,
      payload,
      cb,
    };
  }
  static addMessageSuccess(payload) {
    return {
      type: ADD_MESSAGE_SUCCESS,
      payload,
    };
  }
  static addMessageFailure(payload) {
    return {
      type: ADD_MESSAGE_FAILURE,
      payload,
    };
  }
}
